import type { TransactionEvent } from '@sentry/core'
import isType from './isType'

const groupTransactions = (event: TransactionEvent): TransactionEvent => {
  const { transaction = '' } = event || {}

  const shouldIgnore =
    isType(transaction, '_next') ||
    isType(transaction, '/monitoring') ||
    isType(transaction, 'api')

  if (shouldIgnore) {
    return event
  }
  if (event.transaction) {
    const isStore = isType(transaction, '/store')
    const isCategory = isType(transaction, '/ca/')
    const isProduct = isType(transaction, '/p/')

    if (isStore) {
      event.transaction = `/store`
    }
    if (isCategory) {
      event.transaction = `/ca`
    }
    if (isProduct) {
      event.transaction = `/product`
    }
  }

  return event
}

export default groupTransactions
